import { render, staticRenderFns } from "./checkoutStep.vue?vue&type=template&id=a4ddd57c"
import script from "./checkoutStep.vue?vue&type=script&lang=js"
export * from "./checkoutStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports